import { useEffect } from 'react';
import { generatePath, Outlet, useNavigate, useParams } from 'react-router-dom';
import { useParkingVehicles } from '@repo/domain-service';
import { tr } from '@repo/locale';
import { TestId } from '@repo/test-id';
import { toast } from '@repo/toast';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function ParkingVehicleExistsGuard() {
  const { vehicleId, id: parkingId = '' } = useParams<{ vehicleId: string; id: string }>();
  const navigate = useNavigate();
  const { parkingVehicles, loadingParkingVehicles } = useParkingVehicles({ parkingId });

  const vehicle = parkingVehicles.find((parkingVehicle) => parkingVehicle.id === vehicleId);

  useEffect(() => {
    if (!loadingParkingVehicles && !vehicle) {
      const testId = TestId.root('parkingVehicleExistsGuardError');
      toast.danger(tr('owned_parking_manage:manage.vehicles.errors.vehicle_not_found'), testId);
      navigate(generatePath(ROUTE_PATHS[RouteName.MY_PARKING_MANAGE_VEHICLES], { id: parkingId }), { replace: true });
    }
  }, [loadingParkingVehicles, vehicle, navigate, parkingId]);

  if (!vehicle) {
    return null;
  }

  return <Outlet context={vehicle} />;
}
